import { merge } from "@pdfking/rfunc"
import { IsString, Partial, Sleep } from "@pdfking/tfunc"
import { GENERIC_ERROR } from "@pdfking/translations/enum/errors"
import { get_translations } from "@pdfking/workflow/utils/make_translations"
import uuid from "@pdfking/workflow/utils/uuid"
import delete_property from "@pdfking/workflow/vue/3/delete_property"
import set_property from "@pdfking/workflow/vue/3/set_property"
import virtual from "@pdfking/workflow/vue/3/virtual"
import on from "../dom/on"

export default virtual({
  data: () => {
    return { messages: {} }
  },
  methods: {
    add(m, task) {
      const counter = task ? task.counter : null
      const res = IsString(m) ? { content: m, counter } : merge(m, { counter })
      // @ts-expect-error TS2339
      res.id = res.id || uuid()
      // @ts-expect-error TS2339
      set_property(this.messages, res.id, res)

      // @ts-expect-error TS2339
      const remove = Partial(this.remove, res.id)

      if (task) {
        task.then(remove)
      } else {
        Sleep(5000).then(remove)
      }
    },
    clear() {
      // @ts-expect-error TS2339
      this.messages = {}
    },
    remove(id) {
      // @ts-expect-error TS2339
      return delete_property(this.messages, id)
    },
    send_error(error) {
      return get_translations("errors").then(lib =>
        // @ts-expect-error TS2554
        this.add({
          class: "danger",
          content: lib[error] || lib[GENERIC_ERROR],
        })
      )
    },
  },
  mounted() {
    // @ts-expect-error TS2339
    on("tracked_error", null, (_el, { detail: error }) =>
      this.send_error(error)
    )
  },
})
